export const alphabeticalStringSort = (a: string, b: string) => a.localeCompare(b);
